import * as React from 'react';
import './timeline-list.scss';

export interface TimelineListProps {
    children: React.ReactNode;
    className?: string;
}

export const TimelineList = ({ children, className, ...rest }: TimelineListProps) => (
    <ul className={`timeline-list ${className}`} {...rest}>
        {children}
    </ul>
)
